import { useSyncExternalStore } from 'react';
import axios from 'axios';
import { domain } from './variables';

// Disponibilité du serveur du site : dès qu'un script PHP de server/ répond par une erreur 50x,
// l'application remplace son contenu par la page "site indisponible" (cf. App.js).
// Les services externes (livescore, API FFTT appelées directement...) ne sont pas concernés.
let serverDown = false;
const listeners = new Set();

const setServerDown = () => {
    if (serverDown) return;
    serverDown = true;
    listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

// À appeler dans un composant : true dès qu'une erreur 50x du serveur a été reçue
export const useServerDown = () => useSyncExternalStore(subscribe, () => serverDown);

// Limitation de débit de l'hébergement fftt.com (429 Too Many Requests, parfois 503) :
// elle est appliquée par IP, or sur mobile beaucoup de visiteurs partagent la même IP
// (iCloud Private Relay sur Safari, NAT des opérateurs). On réessaie donc ces appels
// quelques fois en espaçant les tentatives, avant de les considérer en échec.
const MAX_RETRIES = 3;
const RETRY_STATUSES = [429, 503];

// Délai avant la tentative n (0, 1, 2...) : en-tête Retry-After s'il est fourni (plafonné à 10 s),
// sinon 1 s, 2 s, 4 s + un aléa pour que les appels en attente ne repartent pas tous ensemble
const getRetryDelay = (error, attempt) => {
    const retryAfter = Number(error.response?.headers?.['retry-after']);
    if (retryAfter > 0) {
        return Math.min(retryAfter, 10) * 1000;
    }
    return 1000 * 2 ** attempt + Math.random() * 500;
};

// Intercepteur commun à tous les appels axios du site
axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const status = error.response?.status;
        const config = error.config;
        const url = config?.url || '';
        const isServer = url.startsWith(domain + '/server/');

        if (isServer && RETRY_STATUSES.includes(status) && (config.__retryCount || 0) < MAX_RETRIES) {
            const attempt = config.__retryCount || 0;
            config.__retryCount = attempt + 1;
            await new Promise((resolve) => setTimeout(resolve, getRetryDelay(error, attempt)));
            return axios(config);
        }

        if (status >= 500 && status < 600 && isServer) {
            setServerDown();
        }
        return Promise.reject(error);
    }
);
